import React, { useEffect, useState } from 'react';
import {
  Button,
  Typography,
  List,
  ListItem,
  ListItemText,
  TextField,
  MenuItem,
  Menu,
  IconButton,
  ListSubheader,
} from '@material-ui/core';
import { useLocation, useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { css } from '@emotion/core';
import { useRootStore } from '../../stores/BridgeProvider';
import { WideBox, FlexDiv } from '../styles/styles';

import Spinner from '../util/Spinner';

const selectContainer = css`
  flex: 1;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  margin-top: 10px;
  #selectContainerDTT {
    color: blue;
  }
`;

const SelectNewDealTemplateType = () => {
  const history = useHistory();
  // const [isLoading, setLoading] = useState(false);
  // useEffect(() => {
  //   const initialize = async () => {
  //     setLoading(false);
  //   };
  //   initialize();
  // }, []);

  // if (isLoading) return <Spinner />;
  return (
    <FlexDiv>
      <WideBox style={{ maxWidth: '500px' }}>
        <Typography variant="h2" style={{ margin: '0 auto 16px' }}>
          Create a New Deal Template
        </Typography>
        <div css={selectContainer}>
          <div id="selectContainerDTT">
            <List style={{ width: '400px', margin: 'auto' }}>
              <Typography variant="h5" style={{ textAlign: 'left' }}>
                Rental Template
              </Typography>
              <ListItem
                button
                onClick={() =>
                  history.push({
                    pathname: '/deal-templates/wizard',
                    state: { templateId: 'rentStandard' },
                  })
                }
              >
                <ListItemText
                  primary="Standard"
                  secondary="Basic Rental Template"
                />
              </ListItem>
              <ListItem
                button
                onClick={() =>
                  history.push({
                    pathname: '/deal-templates/wizard',
                    state: { templateId: 'rentDetailed' },
                  })
                }
              >
                <ListItemText primary="Detailed" secondary="Advanced" />
              </ListItem>
              <ListItem
                button
                onClick={() =>
                  history.push({
                    pathname: '/deal-templates/wizard',
                    state: { templateId: 'rentTwoTenants' },
                  })
                }
              >
                <ListItemText
                  primary="Two Tenants"
                  secondary="Standard Rental Template For Deal With Two Tenants"
                />
              </ListItem>
              <Typography variant="h5" style={{ textAlign: 'left' }}>
                Sale Template
              </Typography>
              <ListItem
                button
                onClick={() =>
                  history.push({
                    pathname: '/deal-templates/wizard',
                    state: { templateId: 'saleStandard' },
                  })
                }
              >
                <ListItemText
                  primary="Standard"
                  secondary="Basic Sale Template"
                />
              </ListItem>
              <Typography variant="h5" style={{ textAlign: 'left' }}>
                Custom
              </Typography>
              <ListItem
                button
                component={Link}
                to="/deal-templates/new-advanced"
              >
                <ListItemText
                  primary="Create Free Form Template"
                  secondary="Advanced - Some JSON Knowledge Required"
                />
              </ListItem>
            </List>
          </div>
        </div>
      </WideBox>
    </FlexDiv>
  );
};

export default SelectNewDealTemplateType;
